import { GameTestDisplayProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTestDisplayProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
/**
 * TestDisplayPortraitProperties.ts
 */
export class TestDisplayPortraitProperties extends GameTestDisplayProperties {
    constructor() {
        super();
        this.position.set(0, 90);
        this.panelProperties.position.set(0, 90);
        this.panelProperties.layout = new GridLayout(10, 6, 5, 5);
    }
}
//# sourceMappingURL=TestDisplayPortraitProperties.js.map